import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import { toast } from "sonner";
import { MapPin, Phone, Mail } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await new Promise(r => setTimeout(r, 600));
    toast.success("Thank you! We'll be in touch soon via email or WhatsApp.");
    setForm({ name: "", email: "", phone: "", message: "" });
    setLoading(false);
  };

  return (
    <div className="min-h-screen">
      <Navbar />

      <section className="pt-40 pb-16 px-6 lg:px-12" style={{ background: "var(--color-bg-soft)" }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-xs tracking-widest uppercase text-gray-400 mb-3">Get In Touch</div>
          <h1
            className="text-4xl md:text-5xl font-normal text-gray-900"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            Contact Us
          </h1>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16">
          {/* Form */}
          <div>
            <h2
              className="text-2xl font-normal text-gray-900 mb-8"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              Send Us a Message
            </h2>
            <form onSubmit={handleSubmit} className="space-y-5">
              {[
                { name: "name", label: "Full Name", type: "text", required: true },
                { name: "email", label: "Email Address", type: "email", required: true },
                { name: "phone", label: "Phone Number", type: "tel", required: false },
              ].map(field => (
                <div key={field.name}>
                  <label className="text-xs tracking-widest uppercase text-gray-500 block mb-2">
                    {field.label}
                  </label>
                  <input
                    type={field.type}
                    required={field.required}
                    value={form[field.name]}
                    onChange={e => setForm(f => ({ ...f, [field.name]: e.target.value }))}
                    className="w-full border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-gray-900 transition-colors"
                  />
                </div>
              ))}
              <div>
                <label className="text-xs tracking-widest uppercase text-gray-500 block mb-2">
                  Message
                </label>
                <textarea
                  required
                  rows={5}
                  value={form.message}
                  onChange={e => setForm(f => ({ ...f, message: e.target.value }))}
                  className="w-full border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-gray-900 transition-colors resize-none"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="text-xs tracking-widest uppercase font-medium bg-gray-900 text-white px-8 py-4 hover:bg-gray-700 transition-colors disabled:opacity-50 w-full"
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

          {/* Info + Map */}
          <div>
            <h2
              className="text-2xl font-normal text-gray-900 mb-8"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              Visit Our Studio
            </h2>
            <ul className="space-y-5 mb-8">
              <li className="flex items-start gap-4">
                <MapPin size={18} className="text-gray-400 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="text-xs tracking-widest uppercase text-gray-400 mb-1">Address</div>
                  <p className="text-sm text-gray-700">A1303 Spectrum Mall, Phase 1, Sector 75, Noida</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <Phone size={18} className="text-gray-400 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="text-xs tracking-widest uppercase text-gray-400 mb-1">Phone</div>
                  <p className="text-sm text-gray-700">+91 85958 71172</p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <Mail size={18} className="text-gray-400 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="text-xs tracking-widest uppercase text-gray-400 mb-1">Email</div>
                  <p className="text-sm text-gray-700">info@arkdesigninternational.com</p>
                </div>
              </li>
            </ul>

            {/* Google Map embed */}
            <div className="aspect-video w-full bg-gray-100 overflow-hidden">
              <iframe
                title="Ark Design International Location"
                src="https://maps.google.com/maps?q=Spectrum+Mall+Sector+75+Noida&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
